
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { IoLogoTiktok } from 'react-icons/io5';
import styled from 'styled-components';

import FooterColumn from '../molecules/FooterColumn';
import Breadcrumb from './Breadcrumb';
import devices from '@/utilities/devices';

const FooterContainer = styled.footer`
  background-color: ${props => props.theme.color.prune};
  padding: 4em 0;
  color: ${props => props.theme.color.white};
`;

const FooterContentContainer = styled.div`
  display: flex;
  justify-content: center;
  @media screen and (${devices.mobile}) {
    flex-direction: column;
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    flex-direction: column;
  }
`;

const FooterColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1em 2.5em;
  span {
    display: block;
    margin-bottom: 1em;
    padding-right: .3em;
    font-size: 1.2em;
    font-weight: 600;
    color: ${({ theme }) => theme.color.beige};
  }
  a {
    color: ${props => props.theme.color.white};
    text-decoration: none;
    font-size: 1em;
    padding: .15em;
    outline: 0;
    transition: .3s;

    :hover {
      text-decoration: underline;
    }
  }
  div {
    font-size: .95em;
    padding: .2em 0;
  }
  @media screen and (${devices.mobile}) {
    align-items: center;
    span {
      font-size: 1.3em;
      margin-bottom: .5em;
      padding-right: 0em;
    }
    a {
      font-size: .9em;
    }
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    align-items: center;
    span {
      font-size: 1.4em;
      margin-bottom: .5em;
      padding-right: 0em;
    }
    a {
      font-size: .9em;
    }
  }
`;

const SocialFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding: 1em 0em;

  img {
    width: 7em;
    padding-top: .5em;
  }

  .media-social-container {
    white-space: nowrap;
    a {
      display: inline-block;
      font-size: 1.6em;
      text-decoration: none;
      color: ${props => props.theme.color.white};
      padding: .5em .3em .2em;
      outline: 0;
      transition: .2s;
      :hover {
        color: ${props => props.theme.color.beige};
      }
    }
  }
  .copyright {
    font-size: .8em;
  }
  @media screen and (${devices.mobile}) {
    align-items: center;
    img {
      width: 9em;
      padding-top: 1.5em;
    }
    .media-social-container {
      padding: 1em;
      a {
        font-size: 1.4em;
        padding: .5em .5em .2em;
      }
    }
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    align-items: center;
    img {
      width: 10em;
      padding-top: 1.5em;
    }
    .media-social-container {
      padding: 1em;
      a {
        font-size: 1.8em;
        padding: .5em .7em .2em;
      }
    }
  }
`;
const Footer = ({ currentPath }) => {

	const { t } = useTranslation('footer');
	const [showClientMail, setClientMail] = useState(false);
	const [showTalentMail, setTalentMail] = useState(false);
	const [footerContainerWidth, setFooterContainerWidth] = useState(null);

	const setCorrectMailFooter = (url) => {
		const talentUrls = ['trouver-un-emploi', 'find-a-job', 'encontrar-un-empleo', 'offre/'];
		const clientUrls = ['offre-recrutement-reprise', 'activity-restart-offer'];

		if (talentUrls.some(talentUrl => url.includes(talentUrl))) {
			setTalentMail(true);
		} else if (clientUrls.some(clientUrl => url.includes(clientUrl))) {
			setClientMail(true);
		} else {
			setTalentMail(false);
			setClientMail(false);
		}
	};

	useEffect(() => {
		// additon of all footer column element to get total width and pass it to breadcrumbs, so it get the same width
		// ugly fix because this was not defined from the beginning when footer was created
		const totalWidth = document.getElementById('firstColumn').offsetWidth + document.getElementById('secondColumn').offsetWidth + document.getElementById('thirdColumn').offsetWidth + document.getElementById('fourthColumn').offsetWidth + document.getElementById('socialColumn').offsetWidth;
		setFooterContainerWidth(totalWidth);

		setCorrectMailFooter(window.location.href);
	}, []);

	const firstColumn = t('firstColumn', { returnObjects: true });
	const secondColumn = t('secondColumn', { returnObjects: true });
	const thirdColumn = t('thirdColumn', { returnObjects: true });
	const fourthColumn = t('fourthColumn', { returnObjects: true });

	return (
		<FooterContainer>
			<Breadcrumb currentPath={currentPath} footerContainerWidth={footerContainerWidth} />
			<FooterContentContainer>
				<FooterColumnContainer id="secondColumn">
					<FooterColumn column={secondColumn} />
				</FooterColumnContainer>
				<FooterColumnContainer id="thirdColumn">
					<FooterColumn column={thirdColumn} />
				</FooterColumnContainer>
				<FooterColumnContainer id="firstColumn">
					<FooterColumn column={firstColumn} />
				</FooterColumnContainer>
				<FooterColumnContainer id="fourthColumn">
					<FooterColumn column={fourthColumn} />
					{showTalentMail && <div><a href="mailto:hey@bruce.work" name="mail contact"> hey@bruce.work </a></div>}
					{showClientMail && <div><a href="mailto:hello@bruce.work" name="mail contact"> hello@bruce.work </a></div>}
					<div> +33 1 75 85 01 79</div>
				</FooterColumnContainer>

				<SocialFooter id="socialColumn">
					<a href={t('logo.href')}> <img src={t('logo.src')} alt={t('logo.name')} loading="lazy" /> </a>
					<div className="media-social-container">
						<a href="https://www.linkedin.com/company/bruce.work/" name="bruce on Linkedin" aria-label="linkedIn"> <FaLinkedinIn /> </a>
						<a href="https://www.instagram.com/team.bruce/" name="bruce on instagram" aria-label="Instagram"> <FaInstagram /> </a>
						<a href="https://www.facebook.com/TeamBruceFr/" name="bruce on Facebook" aria-label="Facebook"> <FaFacebookF /> </a>
						<a href="https://www.tiktok.com/@brucework/" name="bruce on tiktok" aria-label="Tiktok"> <IoLogoTiktok /> </a>
						<a href="https://twitter.com/bruce_work" name="bruce on Twitter" aria-label="Twitter"> <FaTwitter /> </a>
					</div>
					<div className="copyright">
						© {new Date().getFullYear()} - All Rights Reserved.
					</div>
				</SocialFooter>
			</FooterContentContainer>
		</FooterContainer>
	);
};

export default Footer;
